module.exports = __webpack_public_path__ + "static/media/zhinengtixianappruanjian.09f91577.jpg";